export { default as LandingRoute } from './LandingRoute'
export { default as TeacherRoute } from './TeacherRoute'
export { default as UserRoute } from './UserRoute'